import { PortalErrorStateScheduleEnum } from '../portal-error-state-schedule.enum';

export enum PanelCashOperationsAddResolverErrorStatesEnum {
  GetVendorBankAccountFailed = PortalErrorStateScheduleEnum.PortalCashOperationsAddResolverErrorStatesStartIndex,
  GetCountriesFailed,
  GetCountriesInvalidData,
  GetLinkedAccountsFailed,
}
